import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import moment from "moment";

import navigation_en from "./translations/en/navigation.json";
import aboutMe_en from "./translations/en/about-me.json";
import notification_en from "./translations/en/notification.json";
import password_en from "./translations/en/password.json";
import loginSecurity_en from "./translations/en/login-security.json";
import manMyTeam_en from "./translations/en/manage-my-team.json";
import manMyTeamAssistant_en from "./translations/en/manage-my-team-assistant.json";

import myTeam_en from "./translations/en/my-team.json";
import mfa_en from "./translations/en/mfa.json";
import deleteModal_en from "./translations/en/delete-modal.json";
import mfaModal_en from "./translations/en/mfa-modal.json";
import editModal_en from "./translations/en/edit-modal.json";
import recentActivities_en from "./translations/en/recent-activities.json";
import authenticatorModal_en from "./translations/en/authenticator-modal.json";

const formatHandler = (value, format, lng) => {
    if (format === "uppercase") {
        return value.toUpperCase();
    }

    if (format === "lowercase") {
        return value.toLowerCase();
    }

    if (value instanceof Date) {
        return moment(value).format(format);
    }

    return value;
};

i18n.use(initReactI18next).init({
    fallbackLng: "en",
    interpolation: {
        escapeValue: false, // React already does escaping
        format: formatHandler
    },
    lng: "en",
    resources: {
        en: {
            navigation: navigation_en,
            aboutMe: aboutMe_en,
            notification: notification_en,
            password: password_en,
            loginSecurity: loginSecurity_en,
            manMyTeam: manMyTeam_en,
            manMyTeamAssistant: manMyTeamAssistant_en,
            mfa: mfa_en,
            mfaModal: mfaModal_en,
            myTeam: myTeam_en,
            editModal: editModal_en,
            deleteModal: deleteModal_en,
            recentActivities: recentActivities_en,
            authenticatorModal: authenticatorModal_en
        }
    }
});

export default i18n;
